import { render, staticRenderFns } from "./CrmDashboard.vue?vue&type=template&id=64f8f934&scoped=true"
import script from "./CrmDashboard.vue?vue&type=script&lang=js"
export * from "./CrmDashboard.vue?vue&type=script&lang=js"
import style0 from "./CrmDashboard.vue?vue&type=style&index=0&id=64f8f934&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f8f934",
  null
  
)

export default component.exports